import React from 'react';
import { Progress } from 'antd'

const ProgressCircle = (props) => {
  const { currentStep, totalSteps, percent, style = {} } = props
  return(
    <div style={style}>
      <Progress
        format={(percent, successPercent) => {
          return(
            <div className='progress-indicator-wrapper'>
              <p className='progress-indicator-text'>{`${currentStep}/${totalSteps}`}</p>
            </div>
          )
        }}
        type="circle"
        percent={percent}
        width={40}
        strokeColor={'#63bfc5'}
        trailColor={'#edf3f3'}
        strokeWidth={7}
      />
    </div>
  )
}

export default ProgressCircle


